import { render } from "./Free_phone_dialog.vue?vue&type=template&id=76a47ddd&scoped=true"
import script from "./Free_phone_dialog.vue?vue&type=script&lang=js"
export * from "./Free_phone_dialog.vue?vue&type=script&lang=js"

import "./Free_phone_dialog.vue?vue&type=style&index=0&id=76a47ddd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a47ddd"]])

export default __exports__